import qs from 'qs'

export const queryParticipantsPage = () => {
  const query = qs.stringify(
    {
      populate: {
        ...queryFragmentSingleTypeDefault,
        current_participant_entries: {
          fields: ['title', 'slug']
        },
        upcoming_participant_entries: {
          fields: ['title', 'slug']
        },
        past_participant_entries: {
          fields: ['title', 'slug']
        },
        cover_image: true
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `participants-page?${query}`
}
